import { RootState } from '../../../applicationStore';
import { OrdersState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getOrdersState = (state: RootState): OrdersState => state.orders;

export const getOrdersLoader = createSelector(
  getOrdersState,
  (state): boolean => state.loading,
);

export const getOrdersData = createSelector(
  getOrdersState,
  (state): OrdersState['data'] | null => state?.data || [],
);
